/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AuthActionsTypes, authFailureAction, authSuccessAction } from './Auth.actions';
import { AuthService } from '../../api/services/AuthService';
export var login = function (action$, _state$) {
    return action$.pipe(ofType(AuthActionsTypes.AUTH_REQUEST), mergeMap(function (value) {
        return from(AuthService.login(value.payload.username, value.payload.password)).pipe(map(function (result) { return authSuccessAction(result.status); }), catchError(function (err) { return of(authFailureAction(err)); }));
    }));
};
